export default "__VITE_ASSET__D$FV$RDp__"